import values from "../values";

import { Layout } from "../components";
import {NotFound, PlaceController} from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import SuperAgentContainer from "../screen/SuperAgentScreen";
import ServiceContainer from "../screen/ServiceScreen/Container/Administrator.Container";
import CompanyContainer from "../screen/CompanyScreen/Container/Administrator.container";
import SchoolContainer from "../screen/SchoolScreen/Container";
import DriverContainer from "../screen/DriverScreen/Container/Administrator.container";
import ParentContainer from "../screen/ParentScreen/Container/Administrator.container";
import DashboardContainer from "../screen/DashboardScreen/container";
import AbsentContainer from "../screen/AbsentScreen/Container";
import HistoryContainer from "../screen/LogScreen/Container";
import FinanCialScreen from "../screen/FinancialScreen/";
import GovernmentShipContainer from "../screen/GovernmentShipScreen/Container";
import MunicipalityCityContainer from "../screen/MunicipalityScreen/Container";
import AcademicYearContainer from "../screen/AcademicYearScreen/Container";
import Cookies from "js-cookie";
import constants from "../values/constants";
import UserContainer from "../screen/UserScreen/Container";
import TicketContainer from "../screen/TicketScreen/Container";
import LocationScreen from '../screen/LocationScreen';

const AdministratorRoute = () => {
  let topMenu: any = values.topMenuItems.TOP_MENU_ROLE_ADMIN;

  const financialPermission = Cookies.get(
    constants.USER.FINANCIAL_PERMISSION
  )?.toString();

  const isPrimaryAdmin = Cookies.get(
    constants.USER.IS_PRIMARY_ADMIN
  )?.toString();

  if (isPrimaryAdmin === "false") {
    topMenu = values.topMenuItems.TOP_MENU_ROLE_ADMIN.filter(
      (item: any) => item.pathname !== "/panel/administrator/user"
    );
  }

  if (financialPermission === "false") {
    topMenu = values.topMenuItems.TOP_MENU_ROLE_ADMIN.filter(
      (item: any) => item.pathname !== "/panel/administrator/financial"
    );
  }

  return (
    <Layout topMenuItems={topMenu}>
      <Routes>
        <Route path='/' element={<Navigate to={"super-agent"} />} />

        <Route path='/super-agent/*'     element={<SuperAgentContainer       />} />
        <Route path='/company/*'         element={<CompanyContainer          />} />
        <Route path='/service/*'         element={<ServiceContainer          />} />
        <Route path='/parents/*'         element={<ParentContainer           />} />
        <Route path='/school/*'          element={<SchoolContainer           />} />
        <Route path='/driver/*'          element={<DriverContainer           />} />
        <Route path='/dashboard/*'       element={<DashboardContainer        />} />
        <Route path='/absent/*'          element={<AbsentContainer           />} />
        <Route path='/history/*'         element={<HistoryContainer          />} />
        <Route path='/user/*'            element={<UserContainer             />} />
        <Route path='/ticket/*'          element={<TicketContainer           />} />
        <Route path='/location/*'        element={<LocationScreen            />} />
        <Route path='/academic-year/*'   element={<AcademicYearContainer     />} />
        <Route path='/municipality/*'    element={<MunicipalityCityContainer />} />
        <Route path='/government-ship/*' element={<GovernmentShipContainer   />} />

        {financialPermission === "true" && ( <Route path="/financial/*" element={<FinanCialScreen />} />)}

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default AdministratorRoute;
